import { WIDGET_SHADOW_ROOT_ENABLED_DATA_ATTR } from "@/constants";
import { REWARDS_WIDGET_NAMES } from "@/constants/widget-names";
import { RewardsReferralProgramPageWidgetDefinition } from "@apps/rewards/constants/definitions";
import type { RewardsWidgetInjectorConfig } from "@apps/rewards/types";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import {
    parseOptionalBooleanDataAttr,
    parseStringDataAttr,
} from "@ui-utils/Injector/utils";

const CUSTOMER_IMAGE_URL_ATTR = "gw-img-url";

class RewardsReferralProgramPageWidgetInjector {
    constructor(private readonly config: RewardsWidgetInjectorConfig) {}

    start(): void {
        this.config.logger.debug(
            "RewardsReferralProgramPageWidgetInjector start",
            {
                placeholderSelector: this.config.placeholderSelector,
            }
        );

        const widgetName =
            REWARDS_WIDGET_NAMES.REWARDS_REFERRAL_PROGRAM_PAGE_WIDGET;

        const targets$ = this.config.mutationObserverInjector.register({
            targetSelector: this.config.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.config.logger?.debug(
                "RewardsReferralProgramPageWidgetInjector found placeholder",
                {
                    placeholder,
                }
            );

            const customerImageUrl = parseStringDataAttr(
                placeholder,
                CUSTOMER_IMAGE_URL_ATTR
            );

            void (async () => {
                const RewardsReferralProgramPageWidget =
                    await this.config.dynamicImportManager.importDefault(
                        RewardsReferralProgramPageWidgetDefinition,
                        true
                    );

                const widget = new RewardsReferralProgramPageWidget(
                    {
                        target: placeholder,
                        customerImageUrl,
                        isWidgetShadowRootEnabled: parseOptionalBooleanDataAttr(
                            placeholder,
                            WIDGET_SHADOW_ROOT_ENABLED_DATA_ATTR
                        ),
                    },
                    this.config.logger
                );

                await widget.init();

                this.config.eventsCollector.pushEvent(
                    this.config.eventsFactory.createWidgetInjected(widgetName)
                );

                dispatchSdkEvent(new WidgetInjectedSdkEvent(widgetName));
            })();
        });
    }
}

export default RewardsReferralProgramPageWidgetInjector;
